// extracted by mini-css-extract-plugin
export var progressContainer = "_h1-0";